// imported in main router.ts
export default
	[
		{
			path: "/Login/",
			name: "login",
			component: () => import("@/Login/Login.vue"),
			props: true
		},
		{
			path: "/signup/",
			name: "signup",
			component: () => import("@/Login/RegisterEmail.vue"),
			props: false
		},
		{
			path: "/confirm/",
			name: "confirm",
			component: () => import("@/Login/ConfirmEmail.vue"),
			props: false
		},
		{
			path: "/resetpwd/",
			name: "resetpwd",
			component: () => import("@/Login/ResetPassword.vue"),
			props: false
		},
		{
			path: "/forgottenpassword/",
			name: "forgottenpassword",
			component: () => import("@/Login/ForgottenPassword.vue"),
			props: false
		},
		{
			path: "/resendwelcome/",
			name: "resendwelcome",
			component: () => import("@/Login/ResendWelcome.vue"),
			props: false
		}
	];
